export default {
    baseUrl: {
      dev: 'https://api-test-h5.tuoluoshijie.com',
      test: 'https://api-test-h5.tuoluoshijie.com',
      uat: 'https://api-uat-h5.tuoluoshijie.com',
      preProd: 'https://api-pre-prod-h5.tuoluoshijie.com',
      prod: 'https://api-h5.bixiaocrm.com'
    }
  }
  


// WEBPACK FOOTER //
// ./src/config/index.js